export { getEmailLogsColumns } from './columns';
